<template>
  <div id="app">
    <keep-alive>
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",

  components: {},
  data: function () {
    return {};
  },
  watch: {
    $route(to) {},
  },
  methods: {
    ...mapActions(["sendUserlog"]),
    init: function () {
      let _that = this;
      // _that.checkQuery("client");
      _that.checkQuery("chanid");
      _that.checkQuery("refuid");
      _that.sendUserlog(["open", window.location.href]);
    },
    checkQuery: function (key) {
      let _that = this;
      let storeKey = "jdxb-landing-" + key;
      let value = _that.$route.query[key] ? _that.$route.query[key] : "";
      if (!value) {
        value = localStorage.getItem(storeKey)
          ? localStorage.getItem(storeKey)
          : value;
      }
      localStorage.setItem(storeKey, value);
      _that.$store.state[key] = value;
    },
    checkLogin: function () {
      let _that = this;

      let uid = localStorage.getItem("jdxb-uid");
      uid = uid ? uid : "";
      uid = _that.$route.query.uid ? _that.$route.query.uid : uid;

      let openid = localStorage.getItem("jdxb-openid");
      openid = openid ? openid : "";
      openid = _that.$route.query.openid ? _that.$route.query.openid : openid;

      let owcode = localStorage.getItem("jdxb-owcode");
      owcode = owcode ? owcode : "";
      owcode = _that.$route.query.owcode
        ? decodeURIComponent(_that.$route.query.owcode)
        : owcode;

      let icon = localStorage.getItem("jdxb-avatar");
      icon = icon ? icon : "";
      icon = _that.$route.query.icon ? _that.$route.query.icon : icon;

      let name = localStorage.getItem("jdxb-name");
      name = name ? name : "";
      name = _that.$route.query.name ? _that.$route.query.name : name;

      let phone = localStorage.getItem("jdxb-phone");
      phone = phone ? phone : "";
      phone = _that.$route.query.phone ? _that.$route.query.phone : phone;

      let rkey = localStorage.getItem("jdxb-rkey");
      rkey = rkey ? rkey : "";
      rkey = _that.$route.query.rkey ? _that.$route.query.rkey : rkey;

      let unionid = localStorage.getItem("jdxb-unionid");
      unionid = unionid ? unionid : "";
      unionid = _that.$route.query.unionid
        ? _that.$route.query.unionid
        : unionid;

      let city = localStorage.getItem("jdxb-city");
      city = city ? city : "";
      city = _that.$route.query.city ? _that.$route.query.city : city;

      let province = localStorage.getItem("jdxb-province");
      province = province ? province : "";
      province = _that.$route.query.province
        ? _that.$route.query.province
        : province;

      let newUser = localStorage.getItem("jdxb-newUser");
      newUser = newUser ? newUser : "0";
      newUser = _that.$route.query.newUser
        ? _that.$route.query.newUser
        : newUser;

      let newUserVip = localStorage.getItem("jdxb-newUserVip");
      newUserVip = newUserVip ? newUserVip : "0";
      newUserVip = _that.$route.query.newUserVip
        ? _that.$route.query.newUserVip
        : newUserVip;

      let sex = localStorage.getItem("jdxb-sex");
      sex = sex ? sex : "";
      sex = _that.$route.query.sex ? _that.$route.query.sex : sex;

      let from = localStorage.getItem("jdxb-from");
      from = from ? from : "";
      from = _that.$route.query.refuid ? _that.$route.query.refuid : from;
      let client = localStorage.getItem("jdxb-client");
      client = client ? client : "";
      client = _that.$route.query.client ? _that.$route.query.client : client;
      let version = localStorage.getItem("jdxb-version");
      version = version ? version : "";
      version = _that.$route.query.version
        ? _that.$route.query.version
        : version;
      version = _that.$route.query.appver ? _that.$route.query.appver : version;
      let chanid = localStorage.getItem("jdxb-chanid");
      chanid = chanid ? chanid : "";
      chanid = _that.$route.query.chanid ? _that.$route.query.chanid : chanid;

      // let action = _that.$route.query.action ? _that.$route.query.action : "";
      // if (action == "pay") {
      //   _that.$router.push({ name: "Pay" });
      // }

      _that.$store.state.user.uid = uid;
      _that.$store.state.user.openid = openid;
      _that.$store.state.user.owcode = owcode;
      _that.$store.state.user.icon = icon;
      _that.$store.state.user.name = name;
      _that.$store.state.user.phone = phone;
      _that.$store.state.user.rkey = rkey;
      _that.$store.state.user.unionid = unionid;
      _that.$store.state.user.city = city;
      _that.$store.state.user.province = province;
      _that.$store.state.user.sex = sex;
      _that.$store.state.from = from;
      _that.$store.state.client = client;
      _that.$store.state.version = version;
      _that.$store.state.chan = chanid;
      _that.$store.state.user.newUser = newUser;
      _that.$store.state.user.newUserVip = newUserVip;

      // for test
      // if (process.env.NODE_ENV != "production") {
      //   _that.$store.state.user.uid = "270589";
      //   _that.$store.state.user.owcode = "Ionewu-20220610-*1666~";
      // }

      localStorage.setItem("jdxb-uid", uid);
      localStorage.setItem("jdxb-openid", openid);
      localStorage.setItem("jdxb-owcode", owcode);
      localStorage.setItem("jdxb-avatar", icon);
      localStorage.setItem("jdxb-name", name);
      localStorage.setItem("jdxb-phone", phone);
      localStorage.setItem("jdxb-rkey", rkey);
      localStorage.setItem("jdxb-unionid", unionid);
      localStorage.setItem("jdxb-city", city);
      localStorage.setItem("jdxb-province", province);
      localStorage.setItem("jdxb-sex", sex);
      localStorage.setItem("jdxb-from", from);
      localStorage.setItem("jdxb-client", client);
      localStorage.setItem("jdxb-version", version);
      localStorage.setItem("jdxb-chanid", chanid);
      localStorage.setItem("jdxb-newUser", newUser);
      localStorage.setItem("jdxb-newUserVip", newUserVip);
    },
  },
  mounted: function () {
    let _that = this;
    _that.init();
    // _that.checkLogin();
  },
};
</script>

<style lang="less">
* {
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
}
body::-webkit-scrollbar {
  display: none;
}
body {
  -ms-overflow-style: none;
}
html {
  overflow: -moz-hidden-unscrollable; /*注意！若只打 hidden，chrome 的其它 hidden 会出问题*/
}

/*body {*/
/*	width: calc(100vw + 18px); !*浏览器滚动条的长度大约是 18px*!*/
/*	overflow: auto;*/
/*}*/

#app {
  font-family: "Microsoft Yahei", "微软雅黑", Avenir, Helvetica, Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Chrome/Safari/Opera */
  -khtml-user-select: none;
  /* Konqueror */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
not supported by any browser */
}
</style>

